import React from 'react';
import '../template-file-css/document-file-template.css';


export const ROC_GrievanceProcedure = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='ROC_GrievanceProcedure' className='file-pdf-document'>
            <div className='file-template'>


                <p className='w-750'> <center> Grievance Procedure </center> </p>

                <p className='w-750'>
                    <span className='eleHeader'> Policy</span>


                    It is the policy of Restore Outreach Center, LLC to maintain resolutions records of client grievances for at least two years.
                    <br />
                    It is the policy of Restore Outreach Center, LLC Services to establish guidelines of the timely processing of client grievances as they pertain to Restore Outreach Center, LLC Clients Rights Policy.
                    <br />
                    It is the policy of Restore Outreach Center, LLC to ensure that the program participants have the right to file grievances concerning the services they receive a copy while a program participant.
                    <br />
                    It is the policy of Restore Outreach Center, LLC to appoint a designated client advocate who will assist client in filing a grievance, the client advocate will provide their name title, location, hours of availability, and telephone number included with the posting of client rights which will be posted in Restore Outreach Center, LLC front office.

                </p>
                <p className='w-750'>
                    <span className='eleHeader'> Procedure</span>
                    It shall further be the policy of Restore Outreach Center, LLC
                    <br />
                    to fully support the appointed Client Advocate to take all necessary steps to assure compliance with the following procedures:

                    <ol>
                        <li>Statement to whom the client is to give the grievance.</li>
                        <li>Requirement that the grievance must be put into writing; the grievance may be verbal, and client advocate shall be responsible for preparing a written text of the grievance.</li>
                        <li>Letter may be sent to; 5500 Ridge Rd. Cleveland Ohio, 44129. Restore Outreach Center, LLC.</li>
                        <li>Requirement that the written grievance must be dated and signed by the client, individual filing the grievance on behalf of the client, or have an attestation by the client advocate that the written grievance is true and accurate representation of the client's grievance.</li>
                        <li>Requirement that the grievance include, if available, the date, approximate time, description of the incident and names or individuals involved in the incident or situation being grieved.</li>
                        <li>Statement that the program will make a resolution decision on the grievance within twenty business days of receipt of the grievance. Any extenuating circumstances indicating that this period will need to be extended must be documented in the grievance file and written notification given to the client.</li>
                        <li>Statement that a client has the option to file a grievance with outside organization, that include, but are not limited to, the following, with the mailing address and telephone numbers for each stated:
                            <ul>
                                <li>Board of Alcohol, drug addiction, and mental health services (ADMHS), 2012 W, 25 th St., 6th floor, Cleveland, Ohio, 44113, (216) 241-3400</li>
                                <li>Ohio Department of Mental Health and Addiction Services, 30E. Broad St. Columbus, Ohio 432 15 Suite 742, (614) 466-7264</li>
                                <li>Disability Rights Ohio 200 Civic Center Dr. Columbus, OH 43215 1-800-282-9181 TTY 1800-858-3542</li>
                                <li>Ohio Department of Human Services, Office of Civil Rights Regional Office 10,000 Bessie Cole man Dr. Chicago, IL 60666 (773) 894-2960</li>
                            </ul>
                        </li>
                        <li>Requirement that a written acknowledgment of receipt of the grievance be provided to each grievance. Such acknowledgment shall be provided within three business days from receipt of the grievance. The written acknowledgment shall include, but not be limited to, the following:
                            <ol type='a'>
                                <li>Date grievance was received.</li>
                                <li>Summary of grievance.</li>
                                <li>Overview of grievance investigation process.</li>
                                <li>Timetable for completion of investigation and notification and resolution.</li>
                                <li>Treatment provider contact name, address, and telephone number.</li>
                            </ol>

                        </li>

                    </ol>

                </p>
                <p className='w-750'>
                    Restore Outreach Center, LLC will keep records of grievances it receives, the subject of the grievances, resolutions of each and will ensure the availability of these records for review of Department of Mental Health and Addiction Services upon request. Restore Outreach Center, LLC will also summarize annually its records to include the number of grievances and resolution status for each.
                    <br />

                    Restore Outreach Center, LLC employees/volunteers/contractors will be directly notified within 24 hours through company email about of all modifications to Restore Outreach Center, LLC policies and procedures with revision dates documented with 48 hours to respond and sign documentation.
                    Restore Outreach Center, LLC employees/volunteers/contractors will receive a copy of Restore Outreach Center, LLC written personnel policies and procedures at the time of orientation.
                    <br />
                    Restore Outreach Center, LLC employees/volunteers/contractors will be notified via company email of all modifications in personnel policies and procedures within 24 hours and 48 hours to respond and sign documentation.
                    <br />
                    I,

                    <input type='text' id='txtGrievanceProcedureAcknowledge' name='txtGrievanceProcedureAcknowledge' className='add-only' />
                    acknowledge that the nature and services of this program have been fully explained to me, and I acknowledge I have read, understand, and have received a copy of the Client's Rights and Grievance Procedure.
                    <br />


                    I acknowledge that I have read and fully understand the rules and regulations of the program.


                </p>

                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp;
                        </td>
                        <td className='signature w-375'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Signature of Consumer/Guardian</td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp;
                        </td>
                        <td className='signature w-375'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Staff Signature </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>



            </div>
        </form>

    )
}